import { AjaxLoad } from "./modules/ajax";
import { Form } from "./modules/form";
import { Navigation } from "./modules/navigation";
import { Grid } from "./modules/grid";

window.urls = {};

//modules
document.addEventListener("DOMContentLoaded", function () {
  AjaxLoad.Init();
  Grid.Init();
  Form.Init();
  Navigation.Init();
});

//Require Sass
require("../sass/main.scss");
